import React from 'react';
import { withTranslation } from 'react-i18next';

const LoadableLoading = (props) => {
    if (props.error) {
        // When the loader has errored
        return null;
    } else if (props.timedOut) {
        // When the loader has taken longer than the timeout
        return (
            <div>
                <button onClick={props.retry}>{props.t('golf.nearby.course.retry')}</button>
            </div>
        );
    } else if (props.pastDelay) {
        // When the loader has taken longer than the delay
        return null;
    } else {
        // When the loader has just started
        return null;
    }
};

export default withTranslation(['golf_main'])(LoadableLoading);
